<template>
  <div class="page-container">
    <el-form
      :inline="true"
      class="demo-form-inline toolbar"
      style="padding-bottom: 0px"
    >
      <el-form-item>
        <kt-button
          type="warning"
          icon="el-icon-back"
          label="返回"
          @click="goBack()"
        />
      </el-form-item>
    </el-form>
    <div class="content">
      <el-form
        :model="serviceForm"
        label-width="80px"
        ref="serviceForm"
        :size="size"
        label-position="right"
        class="serviceForm"
      >
        <table>
          <thead>
            <tr style="height: 60px; text-align: center">
              <td colspan="6" style="font-size: 16px; font-weight: 600">
                服务详情
              </td>
            </tr>
          </thead>
          <tbody>
            <tr style="height: 60px; text-align: center">
              <td style="font-size: 14px; font-weight: 600" width="20%">
                服务项目名称
              </td>
              <td
                colspan="2"
                class="serviceTypeName"
                style="text-align: center"
                width="30%"
              >
                <el-form-item label="" label-width="0">
                  <span>{{ serviceForm.serviceName }}</span>
                </el-form-item>
              </td>
              <td style="font-size: 14px; font-weight: 600" width="20%">
                服务类型
              </td>
              <td colspan="2" class="serviceType" width="30%">
                <el-form-item label="" label-width="0">
                  <span v-if="serviceForm.serviceType == 0">小时</span>
                  <span v-else>次</span>
                </el-form-item>
              </td>
            </tr>
            <tr style="height: 60px; text-align: center">
              <td style="font-size: 14px; font-weight: 600" width="20%">
                积分
              </td>
              <td colspan="2" class="integral" width="30%">
                <el-form-item label="" label-width="0">
                  <span>{{ serviceForm.integral }}</span>
                </el-form-item>
              </td>
              <td
                style="font-size: 14px; font-weight: 600; text-align: center"
                width="20%"
              >
                备注
              </td>
              <td colspan="2" class="remark" width="30%">
                <el-form-item label="" label-width="0">
                  <span>{{ serviceForm.remark }}</span>
                </el-form-item>
              </td>
            </tr>
            <tr style="height: 60px; text-align: center">
              <td colspan="6" style="font-size: 16px; font-weight: 600">
                服务流程
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="6" style="font-size: 14px; font-weight: 600">
                <el-row>
                  <el-col :span="2">
                    <el-steps
                      direction="vertical"
                      :active="this.serviceId ? 7 : stepActive"
                      style="padding: 20px 30px; height: 600px; width: 100%"
                    >
                      <el-step title="开始"></el-step>
                      <el-step title="下单"></el-step>
                      <el-step title="接单"></el-step>
                      <el-step title="签到"></el-step>
                      <el-step title="服务"></el-step>
                      <el-step title="签退"></el-step>
                      <el-step title="确认"></el-step>
                    </el-steps>
                  </el-col>
                  <el-col :span="22" style="padding: 108px 15px 40px 15px">
                    <el-row style="padding-bottom: 25px">
                      <el-form-item label="角色名称" class="checkbox">
                        <span v-if="(serviceForm.orderPut = 'admin')"
                          >超级管理员</span
                        >
                      </el-form-item>
                    </el-row>
                    <!-- 接单的超时时长 -->
                    <el-row style="padding: 35px 0px 0px 0px">
                      <el-form-item label="角色名称" class="checkbox">
                        <span v-if="(serviceForm.orderRecv = 'volunteer')"
                          >志愿者</span
                        >
                      </el-form-item>
                    </el-row>
                    <el-row style="line-height: 36px">
                      <el-form-item label="超时时长" class="selectItem">
                        <span>{{ serviceForm.durationRecv }}</span>
                        <span>分钟</span>
                      </el-form-item>
                    </el-row>
                    <!-- 签到的超时时长 -->
                    <el-row
                      style="padding: 24px 0px 25px 0px; line-height: 36px"
                    >
                      <el-form-item label="超时时长" class="selectItem">
                        <span>{{ serviceForm.durationIn }}</span>
                        <span>分钟</span>
                      </el-form-item>
                    </el-row>
                    <!-- 服务的超时时长 -->
                    <el-row
                      style="padding: 35px 0px 0px 0px; line-height: 36px"
                    >
                      <el-col
                        ><kt-button
                          icon=""
                          label="服务内容"
                          type="text"
                          @click="addserviceProcessDialog"
                      /></el-col>
                    </el-row>
                    <!-- 添加display:none 隐藏  暂时去掉服务超时时长 -->
                    <el-row style="line-height: 36px; display: none">
                      <el-form-item label="超时时长" class="selectItem">
                        <span>{{ serviceForm.durationService }}</span>
                        <span>分钟</span>
                      </el-form-item>
                    </el-row>
                    <!-- 签退的超时时长 -->
                    <el-row
                      style="padding: 59px 0px 20px 0px; line-height: 36px"
                    >
                      <el-form-item label="超时时长" class="selectItem">
                        <span>{{ serviceForm.durationOut }}</span>
                        <span>分钟</span>
                      </el-form-item>
                    </el-row>
                    <!-- 确认超时时长 -->
                    <el-row
                      style="padding: 38px 0px 0px 0px; line-height: 36px"
                    >
                      <el-form-item label="角色名称" class="checkbox">
                        <span v-if="(serviceForm.orderPut = 'admin')"
                          >超级管理员</span
                        >
                      </el-form-item>
                    </el-row>
                    <el-row style="line-height: 36px">
                      <el-form-item label="超时时长" class="selectItem">
                        <span>{{ serviceForm.durationConfirm }}</span>
                        <span>分钟</span>
                      </el-form-item>
                    </el-row>
                  </el-col>
                </el-row>
              </td>
            </tr>
          </tfoot>
        </table>
      </el-form>
    </div>
    <!-- 巡查服务流程dialog模态框-->
    <el-dialog
      class="serviceProcessdialog"
      title="巡查服务流程"
      width="45%"
      :visible.sync="serviceProcessDialogVisible"
      :close-on-click-modal="false"
    >
      <el-table
        :data="serviceProcessList"
        style="width: 100%"
        :row-style="tableRowStyle"
        :header-cell-style="tableHeaderColor"
      >
        <el-table-column style="height: 65px" label="流程顺序" align="center">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="服务内容名称"
          style="width: 20% height:65px;"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="!scope.row.editeFlage" style="margin-left: 10px">{{
              scope.row.itemName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="服务内容类型"
          style="width: 20% height:65px;"
          align="center"
        >
          <template slot-scope="scope">
            <span
              v-if="!scope.row.editeFlage && scope.row.itemType == 0"
              style="margin-left: 10px"
              >拍照</span
            >
            <span
              v-else-if="!scope.row.editeFlage && scope.row.itemType == 1"
              style="margin-left: 10px"
              >异常报告</span
            >
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="100"
          align="center"
          style="height: 65px"
        >
          <template slot-scope="scope">
            <el-button
              type="info"
              size="mini"
              @click="handleDetailServiceItem(scope.$index, scope.row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button
          :size="size"
          type="primary"
          @click.native="serviceProcessDialogVisible = false"
          >关闭</el-button
        >
      </div>
    </el-dialog>
    <!-- 新增异常报告dialog模态框-->
    <el-dialog
      class="exceptionReportingdialog"
      title="异常报告"
      width="30%"
      :visible.sync="exceptionReportingDialogVisible"
      :close-on-click-modal="false"
    >
      <el-table
        :data="reportItemDtos"
        style="width: 100%"
        :row-style="tableRowStyle"
        :header-cell-style="tableHeaderColor"
      >
        <el-table-column
          label="异常报告内容"
          style="width: 20% height:65px;"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="!scope.row.editeFlage" style="margin-left: 10px">{{
              scope.row.reportItemContent
            }}</span>
            <input
              type="text"
              class="el-input__inner"
              v-if="scope.row.editeFlage"
              style="width: 120px"
              v-model.trim="scope.row.reportItemContent"
              placeholder="请输入"
              @input="changeServiceContentEdit"
            />
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button
          type="primary"
          :size="size"
          @click.native="exceptionReportingDialogVisible = false"
          >关闭</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import KtButton from "@/components/KtButton";
export default {
  components: {
    KtButton,
  },
  data() {
    return {
      serviceId: "", //服务小项的服务id
      size: "medium",
      formLabelWidth: "110px",
      serviceForm: {
        serviceName: "",
        serviceType: "",
        integral: "",
        remark: "",
        orderPut: [],
        orderRecv: [],
        orderConfirm: [],
        durationRecv: "", //接单超时时间
        durationIn: "", //签到超时时间
        durationService: "", //服务超时时间
        durationOut: "", //签退超时时间
        durationConfirm: "", //确认超时时间
      },
      stepActive: 0, //步骤条激活的状态
      serviceProcessList: [], //巡查服务的集合
      serviceProcessDialogVisible: false, //巡查服务过程界面是否显示
      serviceItemDialogVisible: false, //服务子项目界面是否显示
      exceptionReportingDialogVisible: false, //异常报告界面是否显示
      reportItemDtos: [], //异常报告table集合
      itemOrder: "",
      serviceItemId: "",
    };
  },
  methods: {
    goBack() {
      console.log("返回上层");
      bus.$emit('close_current_tags');
    },
    //巡查服务流程的模态框显示
    addserviceProcessDialog() {
      this.serviceProcessDialogVisible = true;
      this.getItemService();
    },
    //服务内容模态框显示
    addProcess() {
      this.serviceItemDialogVisible = true;
    },
    //服务内容子项目详情
    handleDetailServiceItem(index, row) {
      console.log(index, row);
      //判断服务内容类型itemType为0时是拍照 itemType为1时是异常报告
      if (row.itemType == 1) {
        this.exceptionReportingDialogVisible = true;
        this.getExceptionReporting(row.id);
      } else {
        this.$message({ message: "该服务类型没有详情！", type: "error" });
      }
    },
    //查询服务子项目的table数据
    getItemService() {
      let serviceId = this.serviceId;
      console.log(serviceId);
      if (serviceId) {
        this.$postJson(
          "omc/serviceItem/queryListByServiceId/" + serviceId
        ).then((res) => {
          console.log(res);
          if (res.result != null) {
            var serviceItemArr = [];
            res.result.forEach((item, index) => {
              var serviceItemObj = {};
              serviceItemObj.editeFlage = false;
              serviceItemObj.index = index;
              serviceItemObj.id = item.id;
              serviceItemObj.serviceId = item.serviceId;
              serviceItemObj.itemContent = item.itemContent;
              serviceItemObj.itemOrder = item.itemOrder;
              serviceItemObj.itemName = item.itemName;
              serviceItemObj.itemType = item.itemType;
              serviceItemArr.push(serviceItemObj);
            });
            this.serviceProcessList = serviceItemArr;
            console.log(this.serviceProcessList);
          }
        });
      }
    },
    //查询异常报告的table数据
    getExceptionReporting(id) {
      let serviceItemId = id;
      if (serviceItemId) {
        this.$postJson(
          "omc/reportItem/queryListByServiceItemId/" + serviceItemId
        ).then((res) => {
          console.log(res);
          if (res.result != null) {
            var exceptionReportingArr = [];
            res.result.forEach((item, index) => {
              var exceptionReportingObj = {};
              exceptionReportingObj.editeFlage = false;
              exceptionReportingObj.index = index;
              exceptionReportingObj.id = item.id;
              exceptionReportingObj.serviceItemId = item.serviceItemId;
              exceptionReportingObj.reportItemContent = item.reportItemContent;
              exceptionReportingObj.reportOrder = item.reportOrder;
              exceptionReportingArr.push(exceptionReportingObj);
            });
            this.reportItemDtos = exceptionReportingArr;
            console.log(this.reportItemDtos);
          }
        });
      }
    },
    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #e4f5f8";
      } else {
        return "background-color: #f9f9f9";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#bee1f4;color:#6f7075;font-weight: 500;";
      }
    },
    //获取跳转传递过来的query值
    getRouteQueryInfo() {
      if (this.$route.query.res) {
        //接收parmas传递的一个对象
        let data = JSON.parse(this.$route.query.res);
        data.serviceType == "小时"
          ? (data.serviceType = 0)
          : (data.serviceType = 1);
        data.integral = data.integral + "";
        switch (data.orderPut) {
          case "超级管理员":
            data.orderPut = "admin";
            break;
          case "志愿者":
            data.orderPut = "volunteer";
            break;
          default:
            data.orderPut = "";
        }
        switch (data.orderRecv) {
          case "超级管理员":
            data.orderRecv = "admin";
            break;
          case "志愿者":
            data.orderRecv = "volunteer";
            break;
          default:
            data.orderRecv = "";
        }
        switch (data.orderConfirm) {
          case "超级管理员":
            data.orderConfirm = "admin";
            break;
          case "志愿者":
            data.orderConfirm = "volunteer";
            break;
          default:
            data.orderConfirm = "";
        }
        console.log(data);
        this.serviceForm = Object.assign({}, data);
        var orderPutList = [];
        var orderRecvList = [];
        var orderConfirmList = [];
        orderPutList.push(data.orderPut);
        orderRecvList.push(data.orderRecv);
        orderConfirmList.push(data.orderConfirm);
        this.serviceForm.orderPut = orderPutList;
        this.serviceForm.orderRecv = orderRecvList;
        this.serviceForm.orderConfirm = orderConfirmList;
        this.serviceId = data.id;
        console.log(this.serviceId);
      }
    },
  },
  created() {
    this.getRouteQueryInfo();
  },
  mounted() {
    this.getRouteQueryInfo();
  },
};
</script>
<style lang="scss" scoped>
.page-container {
  height: 500px;
  display: flex;
  flex-direction: column;
  background: #fff;
  .demo-form-inline {
    height: 60px;
  }
  .content {
    margin: 0px 0 30px 0;
    width: 100%;
    flex: 1;
    background: #fff;
    table {
      width: 100%;
      margin: 10px auto;
      border-collapse: collapse;
      border: 1px solid #cccccc;
    }
    td {
      border: 1px solid #cccccc;
    }
    .serviceTypeName,
    .serviceType,
    .integral,
    .remark,
    .checkbox,
    .selectItem {
      position: relative;
    }
    ::deep .serviceTypeName .el-form-item__error {
      position: absolute;
      left: 110px;
      top: 98%;
    }
    ::deep .serviceType .el-form-item__error {
      position: absolute;
      left: 115px;
      top: 98%;
    }
    ::deep .integral .el-form-item__error {
      position: absolute;
      left: 110px;
      top: 98%;
    }
    ::deep .remark .el-form-item__error {
      position: absolute;
      left: 115px;
      top: 98%;
    }
    ::deep .checkbox .el-form-item__error {
      position: absolute;
      top: 55%;
    }
    ::deep .selectItem .el-form-item__error {
      position: absolute;
      top: 100%;
    }
  }
  // ::deep深度作用选择符
  ::deep .el-dialog__header {
    text-align: left;
    background: rgb(238, 231, 231);
    border-bottom: 2px solid rgb(211, 207, 207);
  }
  //新增服务内容的dialog模态框
  ::deep .serviceProcessdialog .el-dialog .el-dialog__body {
    padding: 10px 20px 30px 20px;
    height: 400px;
    overflow-y: scroll;
  }
  ::deep .serviceForm .el-form-item {
    margin-bottom: 0px;
  }
  //新增异常报告的dialog模态框
  ::deep .exceptionReportingdialog .el-dialog .el-dialog__body {
    padding: 10px 20px 30px 20px;
    height: 400px;
    overflow-y: scroll;
  }
  //服务内容的 dialog
  @media screen and (max-width: 1350px) {
    ::deep .serviceProcessdialog .el-dialog {
      width: 60% !important;
    }
  }
  @media screen and (max-width: 1100px) {
    ::deep .serviceProcessdialog .el-dialog {
      width: 90% !important;
    }
  }
  //服务子项目 dialog
  @media screen and (max-width: 1350px) {
    ::deep .serviceItemdialog .el-dialog {
      width: 50% !important;
    }
  }
  @media screen and (max-width: 1300px) {
    ::deep .serviceItemdialog .el-dialog {
      width: 58% !important;
    }
  }
  @media screen and (max-width: 1250px) {
    ::deep .serviceItemdialog .el-dialog {
      width: 60% !important;
    }
  }
  //异常报告 dialog
  @media screen and (max-width: 1350px) {
    ::deep .exceptionReportingdialog .el-dialog {
      width: 45% !important;
    }
  }
  @media screen and (max-width: 1100px) {
    ::deep .exceptionReportingdialog .el-dialog {
      width: 60% !important;
    }
  }
}
</style>
